import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "spinner"];

  removeAccount(event) {
    event.preventDefault();

    console.log("RemoveBankAccountController: removeAccount");
    const form = this.formTarget;
    const accountId = form.dataset.accountId;

    this.removeButtonDisabled();
    this.cancelButtonDisabled();
    this.showSpinner();

    form.action = `/withdraw/remove-bank-account/${accountId}/`;
    form.method = "POST";
    form.requestSubmit();
  }

  onSubmitEnd(event) {
    console.log("RemoveBankAccountController: event", event);

    const response = event.detail.fetchResponse;

    if (response.succeeded) {
      setTimeout(() => {
        Turbo.visit("/withdraw/linked-bank-accounts", { action: "replace" });
        this.hideSpinner();
      }, 1200);
    }
  }

  removeButtonDisabled() {
    const button = document.getElementById("remove-button");
    const text = document.getElementById("remove-button-text");
    if (button) {
      button.disabled = true;
      button.classList.add("cursor-not-allowed", "opacity-50");
    }
    if (text) text.textContent = "Removing...";
  }

  cancelButtonDisabled() {
    const button = document.getElementById("cancel-button");
    if (button) {
      button.style.pointerEvents = "none";
      button.classList.add("cursor-not-allowed", "opacity-50");
    }
  }

  showSpinner() {
    if (this.spinnerTarget) this.spinnerTarget.classList.remove("hidden");
  }

  hideSpinner() {
    if (this.spinnerTarget) this.spinnerTarget.classList.add("hidden");
  }
}
